import type { ComponentContentSchema } from '@vibesites/runtime';
import { useContentToken, RichTextContent } from '@vibesites/runtime/react';

function hasValue(val: string | null | undefined): val is string {
  if (!val) return false;
  const normalized = val.trim().toLowerCase();
  return normalized !== '' && normalized !== 'false' && normalized !== 'null' && normalized !== 'undefined';
}

/**
 * Pricing disclaimer above the floor plans grid. Bound to
 * `custom_pricing_verbiage` and hidden when that field is empty.
 */
export function FloorPlansIntro() {
  const pricingVerbiage = useContentToken('floorplansintro.pricing_verbiage');

  if (!hasValue(pricingVerbiage)) return null;

  return (
    <section className="w-full bg-background pb-6 pt-8 md:pb-8 md:pt-10">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6 lg:px-8">
        <RichTextContent
          path="floorplansintro.pricing_verbiage"
          label="Pricing Verbiage"
          as="p"
          className="font-body text-sm leading-relaxed text-muted-foreground sm:text-base [&_p]:mb-0 [&_a]:text-primary [&_a]:underline"
        />
      </div>
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'FloorPlansIntro',
  displayName: 'Floor Plans Intro',
  tokens: {
    'floorplansintro.pricing_verbiage': {
      label: 'Pricing Verbiage',
      type: 'richtext',
      defaultField: 'custom_pricing_verbiage',
    },
  },
};

(FloorPlansIntro as unknown as { contentSchema: ComponentContentSchema }).contentSchema =
  contentSchema;

export default FloorPlansIntro;
